import React from "react";
import classNames from "classnames/bind";

import styles from "./FollowingList.module.scss";
const cx = classNames.bind(styles);

const Item = ({ data }) => {
  return (
    <li className={cx("item")}>
      <div className={cx("left-section")}>
        <img src={data.image} alt="..." />
        <span>{data.name}</span>
      </div>
      <div className={cx("right-section")}>
        <button className={cx("unfollow")}>Unfollow</button>
        <button className={cx("follow")}>Following</button>
      </div>
    </li>
  );
};

export default Item;
